/** This class is mainly for animating anything seamlessly and smoothly.
 *  If you modify the "end", end you keep calling "update", then start will get closer and closer to the value of "end"
 *  The higher the dampingFactor is, the faster the "animation" is. It should be between 0 and 1.*/

export class Convergence {
    constructor(start, end, dampingFactor) {
        if (dampingFactor === undefined) { dampingFactor = 0.1; }

        this._originalStart = start;
        this._start = start;
        this._originalEnd = end;
        this._end = end;
        this._dampingFactor = dampingFactor;
    }

    increaseEndBy(value) { this._end += value; };
    decreaseEndBy(value) { this._end -= value; }

    get start() { return this._start; }

    get end() { return this._end; }
    set end(value) { this._end = value; }

    reset(start, end) {
        this._start = start !== null ? start : this._originalStart;
        this._end = end !== null ? end : this._originalEnd;
    }

    update() {
        this._start += (this._end - this._start) * this._dampingFactor;
    }
}